"use client";

import { getDefaultUrl, windowIsExist } from "@/utils";
import { getCookieValue, setCookieValue } from "@/utils/cookies";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { utmList } from "../../utils/cookies";
import { isObjectEmpty } from "../objects";

function containsUTMParams(url: string): boolean {
  const urlObj = new URL(url);
  return utmList.some((param) => urlObj.searchParams.has(param));
}

export const setUtmInCookies = (searchParams: URLSearchParams) => {
  // Recuperar el estado actual de las cookies
  const existingUtmCookie = getCookieValue("utm_params") || {};
  const existingTagCookie = getCookieValue("tag_param") || {};

  // Contenedor para nuevos valores
  const newUtmParams: Record<string, string> = {};
  let newTagParam: string | null = null;

  // Iterar sobre la lista de parámetros UTM permitidos
  for (const utm of utmList) {
    const value = searchParams.get(utm);
    if (!value) continue;

    if (utm === "tag") {
      newTagParam = value;
      continue;
    }

    newUtmParams[utm] = value;
  }

  // Actualizar cookie de tag si corresponde y no estamos en la página de pago
  const isPaymentPage = windowIsExist && window.location.pathname.startsWith("/payment"); // no borrar para que se mantenga el tag para pruebas de QA

  if (newTagParam && !isPaymentPage) {
    setCookieValue("tag_param", {
      ...existingTagCookie,
      tag: newTagParam,
    });
  }

  // Solo actualizar la cookie de UTM si hay algo nuevo
  if (!isObjectEmpty(newUtmParams)) {
    setCookieValue("utm_params", {
      ...existingUtmCookie, // mantenemos lo previo
      ...newUtmParams, // sobrescribimos lo nuevo
    });
  }
};

export const getUtmsCookies = () => {
  const cookieUtm = getCookieValue("utm_params");
  if (!cookieUtm && !isObjectEmpty(cookieUtm)) return;

  let data: Record<string, string | undefined> = {};

  utmList.forEach((key: string) => {
    if (!cookieUtm[key]) return;
    data[key] = cookieUtm[key];
  });

  return data;
};

const UtmComponent = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const siteUrl = getDefaultUrl();
    if (containsUTMParams(siteUrl)) {
      setUtmInCookies(searchParams);
    }
  }, [searchParams]);

  return null;
};

export default UtmComponent;
